import { render, staticRenderFns } from "./superiors_table.vue?vue&type=template&id=abcea036"
import script from "./superiors_table.vue?vue&type=script&lang=js"
export * from "./superiors_table.vue?vue&type=script&lang=js"
import style0 from "./superiors_table.vue?vue&type=style&index=0&id=abcea036&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports